import { Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {VersionCheckService} from "./version-check.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  constructor(private translate: TranslateService, private versionCheck: VersionCheckService) {
    translate.setDefaultLang('it');
    translate.use('it');
  }
  ngOnInit(){
    const url = new URL(window.location.href);
    if (url.searchParams.has('_reload')) {
      url.searchParams.delete('_reload');
      window.history.replaceState({}, document.title, url.pathname);
    }

    this.versionCheck.initVersionCheck(60000);
  }
}
